import { render, staticRenderFns } from "./SelecionadosListagem.vue?vue&type=template&id=be636322&scoped=true"
import script from "./SelecionadosListagem.vue?vue&type=script&lang=js"
export * from "./SelecionadosListagem.vue?vue&type=script&lang=js"
import style0 from "./SelecionadosListagem.vue?vue&type=style&index=0&id=be636322&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be636322",
  null
  
)

export default component.exports